function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunburst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1865.71,-907.035)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17188,0,0,1.17188,1865.71,907.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.058,0L256.058,30.912C380.403,30.912 481.204,131.714 481.204,256.058L504.265,256.058C508.61,256.058 512.128,252.475 511.996,248.133C507.808,110.383 394.824,0 256.058,0Z",
    style: {
      fill: "rgb(0,172,109)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.058,0C394.824,0 507.808,110.383 511.996,248.133C512.128,252.475 508.61,256.058 504.265,256.058L481.204,256.058C481.204,114.641 380.403,0 256.058,0Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.058,0C380.403,0 481.204,114.641 481.204,256.058L457.87,256.058C453.729,256.058 450.309,252.793 450.153,248.655C448.253,197.962 426.927,152.239 393.402,118.714C358.253,83.566 309.694,61.825 256.058,61.825L256.058,0Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.275,128.012C78.552,51.488 161.29,0 256.058,0L256.058,61.825C184.171,61.825 121.405,100.878 87.819,158.925L34.275,128.012ZM141.37,189.843C164.266,150.272 207.053,123.65 256.058,123.65C207.053,123.65 164.269,150.274 141.373,189.845L141.37,189.843Z",
    style: {
      fill: "rgb(61,87,211)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.275,384.105C12.48,346.437 -0,302.706 -0,256.058C-0,209.41 12.48,165.679 34.275,128.012L87.819,158.925C71.287,187.498 61.825,220.673 61.825,256.058C61.825,291.443 71.287,324.618 87.819,353.191L34.275,384.105ZM141.37,189.843L141.373,189.845C131.307,207.243 125.083,227.143 123.869,248.385C125.083,227.143 131.304,207.241 141.37,189.843Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.058,450.292L256.058,504.264C256.058,508.609 252.475,512.128 248.132,511.996C156.689,509.216 77.313,458.487 34.275,384.105L87.819,353.191C121.405,411.239 184.171,450.292 256.058,450.292Z",
    style: {
      fill: "rgb(243,205,81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.825,256.058C61.825,148.786 148.786,61.825 256.058,61.825C309.694,61.825 358.253,83.566 393.402,118.714L354.995,157.122C352.103,160.013 347.451,160.162 344.406,157.432C320.971,136.426 290.006,123.65 256.058,123.65C182.932,123.65 123.651,182.93 123.65,256.058L61.825,256.058Z",
    style: {
      fill: "rgb(253,156,76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.685,349.685L387.821,387.822C390.942,390.942 390.805,396.021 387.558,399.009C352.964,430.849 306.781,450.292 256.058,450.292C148.786,450.292 61.825,363.331 61.825,256.058L123.65,256.058C123.649,329.116 183,388.467 256.058,388.467C292.622,388.467 325.724,373.646 349.685,349.685Z",
    style: {
      fill: "rgb(255,127,22)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.312,262.923C322.757,299.762 290.883,328.321 252.725,326.565C216.564,324.902 187.215,295.552 185.552,259.393C183.796,221.234 212.355,189.36 249.195,185.806C253.11,185.427 256.058,182.06 256.058,178.126L256.058,123.65C182.932,123.65 123.651,182.93 123.65,256.057C123.649,329.116 183,388.467 256.058,388.467C326.434,388.467 383.984,333.563 388.216,264.253C388.487,259.811 384.944,256.058 380.492,256.058L333.991,256.058C330.057,256.058 326.69,259.007 326.312,262.923Z",
    style: {
      fill: "rgb(240,0,180)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunburst);
export default __webpack_public_path__ + "static/media/sunburst.3e90887bf37c77eed6cac66f383f2ff4.svg";
export { ForwardRef as ReactComponent };